import { MeasureDocuments } from "./measure-documents.model";

export class MeasureDocumentsSummary {
    projectId: number;
    isDocumentHasTimeFrame: boolean;
    measureDocumentsList: MeasureDocuments[];
    projectTypeId: number;

    constructor(options: {
        projectId: number;
        isDocumentHasTimeFrame: boolean;
        measureDocumentsList: MeasureDocuments[];
        projectTypeId: number;
    }) {
        this.projectId = options.projectId;
        this.isDocumentHasTimeFrame = options.isDocumentHasTimeFrame;
        this.measureDocumentsList = options.measureDocumentsList || [];
        this.projectTypeId = options.projectTypeId;
    }

    get hasMeasureDocumentsList(): boolean {
      return Array.isArray(this.measureDocumentsList) && this.measureDocumentsList.length > 0;
    }
}
